const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);
const columnSections = $$(".two-column-default");

columnSections.forEach(function(section) {
  const columns = $$(".column:nth-child(even)", section);

  columns.forEach(function(column) {
    if ($("p:first-child:last-child img:first-child:last-child", column)) {
      const previousSibling = column.previousElementSibling;
      const previousPosition = getComputedStyle(previousSibling).getPropertyValue("--position");
      const currentPosition = getComputedStyle(column).getPropertyValue("--position");

      column.style.setProperty("--mobile-position", previousPosition);
      previousSibling.style.setProperty("--mobile-position", currentPosition);
      previousSibling.classList.add("flipped");
    }
  });
});